import licenseModule from '../../license.module';

export default licenseModule.component('licenseViewLicense', {
    template: require('./licenseViewLicense.component.html'),
    controller: ['LicenseManagementService', licenseViewLicenseComponent],
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});

function licenseViewLicenseComponent(LicenseManagementService) {
    var vm = this;
    vm.$onInit = function() {
        var navs = [
            {
                label: 'License',
                value: 'license'
            }
        ];
        vm.nav = {
            options: {},
            items: navs,
            step: 0,
            selected: navs[0],
            selectedValue: function() {
                return this.selected.value;
            }
        };
        vm.data = vm.resolve.data;

        // Retrieve license payload from the API
        // GET /api/v2/accounts/{account_guid}/instances/{instance_guid}/activation
        LicenseManagementService.getInstanceActivation(vm.data.id).then(
            function(data) {
                LicenseManagementService.get64CharPayload(data.payload).then(
                    function(data) {
                        vm.license = data;
                        if (vm.license != undefined && vm.license != '') {
                            vm.payload = vm.license;
                            vm.hidecopybutton = false;
                        }
                    },
                    function() {
                        vm.payload =
                            'Failed to generate license. Please try again. If the problem persists, please contact Appspace Support. ';
                        vm.hidecopybutton = true;
                    }
                );
            },
            function() {
                vm.payload =
                    'Failed to generate license. Please try again. If the problem persists, please contact Appspace Support. ';
                vm.hidecopybutton = true;
            }
        );
    };

    vm.ok = function() {
        vm.close({ $value: vm.license });
    };
}



// WEBPACK FOOTER //
// ./modules/license/features/license-view-license/licenseViewLicense.component.js